const HEROKU: string = "https://sushi-market.herokuapp.com"

export {
    HEROKU
}